import { connect } from "react-redux";

import qs from "qs";
import Component from "./Component";

const mapStateToProps = (state, { match }) => {
    const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    const gameId = match?.params?.id;
    const privateCode = searchParams.code;

    return { gameId, privateCode };
};

export default connect(mapStateToProps)(Component);
